webpackJsonp([16192702802281],{

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DirectionsButtonModule = __webpack_require__(180);
	
	var _DirectionsButtonModule2 = _interopRequireDefault(_DirectionsButtonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DIRECTION_URL = 'https://www.google.com/maps/dir/?api=1&destination=10510+Stone+Ave+N,+Seattle,+WA+98133';
	
	var DirectionsButton = function DirectionsButton() {
	  return _react2.default.createElement(
	    'a',
	    {
	      className: _DirectionsButtonModule2.default.component,
	      href: DIRECTION_URL,
	      target: '_blank',
	      rel: 'noopener noreferrer'
	    },
	    'Get Directions'
	  );
	};
	
	exports.default = DirectionsButton;
	module.exports = exports['default'];

/***/ }),

/***/ 180:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"component":"src-components-DirectionsButton----DirectionsButton-module---component---2y7Ni"};

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationPageQuery = exports.LocationPageTemplate = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(30);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Page = __webpack_require__(31);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _DirectionsButton = __webpack_require__(118);
	
	var _DirectionsButton2 = _interopRequireDefault(_DirectionsButton);
	
	var _locationModule = __webpack_require__(334);
	
	var _locationModule2 = _interopRequireDefault(_locationModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LocationPageTemplate = exports.LocationPageTemplate = function LocationPageTemplate(_ref) {
	  var title = _ref.title,
	      content = _ref.content;
	  return _react2.default.createElement(
	    _Page2.default,
	    { title: 'Location', className: _locationModule2.default.component },
	    _react2.default.createElement(_reactHelmet2.default, { title: title + ' | Location' }),
	    _react2.default.createElement(
	      'article',
	      { className: _locationModule2.default.article },
	      _react2.default.createElement(
	        'h2',
	        { className: _locationModule2.default.articleTitle },
	        title
	      ),
	      _react2.default.createElement('div', {
	        className: _locationModule2.default.articleContent,
	        dangerouslySetInnerHTML: { __html: content }
	      }),
	      _react2.default.createElement(_DirectionsButton2.default, null)
	    )
	  );
	};
	
	var LocationPage = function LocationPage(_ref2) {
	  var data = _ref2.data;
	  var page = data.markdownRemark;
	  var title = page.frontmatter.title,
	      html = page.html;
	
	
	  return _react2.default.createElement(LocationPageTemplate, { title: title, content: html });
	};
	
	LocationPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = LocationPage;
	var locationPageQuery = exports.locationPageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 334:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"article":"src-templates----location-module---article---2ZwUy","articleTitle":"src-templates----location-module---articleTitle---3hfGM","articleContent":"src-templates----location-module---articleContent---1v2O6"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-location-js-e456b493f4c534a6161b.js